import React, { useContext } from "react";
import { Modal, Input, Heading, Flex, Button } from "@cisco/spaces-dash-lib-styleguide";
import { I18nContext } from "../../../contexts/i18nContext";

export default function LocationRenamePopup(props) {
  const i18n = useContext(I18nContext);
  const { showRenamePopup, cancelRename, locationName, setLocationName, renameLocation } = props;

  return (
    <Modal size="sm" isOpen={showRenamePopup}>
      <Flex direction="vertical" gap={12}>
        <Heading as="h2" size="primary">
          {i18n.t("business-location-details.rename-location-text")}
        </Heading>
        <Modal.Content>
          <Flex justify="center" style={{ margin: "32px 0" }}>
            <div style={{ width: "100%" }}>
              <Input type="text" size="md" id="rename-loc" label={i18n.t("business-location-details.rename-location-text")} value={locationName} onChange={(e) => setLocationName(e.target.value)} />
            </div>
          </Flex>
        </Modal.Content>

        <Flex justify="flex-end" align="center">
          <Button.Group>
            <Button kind="tertiary" onClick={cancelRename}>
              {i18n.t("business-location-details.cancel-text")}
            </Button>
            <Button onClick={renameLocation} data-testid="lh20-rename-btn">
              {i18n.t("business-location-details.rename-text")}
            </Button>
          </Button.Group>
        </Flex>
      </Flex>
    </Modal>
  );
}
